import React from 'react';
import PropTypes from 'prop-types';
import { AlertIcon } from 'assets/materialIcons/materialIcons';
import Loader from 'components/loading/Loader';
import styled from 'styled-components';
import { IconButton } from 'material-ui';

const StyledTooltipContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledTooltipWrapper = styled.div`
    position: absolute;
    transform: translateY(-32px);
`;

const StyledIconButton = styled(IconButton)`
    padding: 0 !important;
    width: auto !important;
    height: 100% !important;
`;

class AutoCompleteTooltip extends React.Component {
    render() {
        const {
            error,
            loading,
        } = this.props;

        if (!loading && !error) {
            return null;
        }

        if (loading) {
            return (
                <StyledTooltipContainer>
                    <StyledTooltipWrapper>
                        <Loader size={ 20 } />
                    </StyledTooltipWrapper>
                </StyledTooltipContainer>
            );
        }

        return (
            <StyledTooltipContainer>
                <StyledTooltipWrapper>
                    <StyledIconButton tooltip={ error && error } tooltipPosition='top-left' ><AlertIcon /></StyledIconButton>
                </StyledTooltipWrapper>
            </StyledTooltipContainer>
        );
    }
}

AutoCompleteTooltip.propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool,
};

export default AutoCompleteTooltip;


// WEBPACK FOOTER //
// ./src/components/list/Filters/types/autocomplete/AutoCompleteTooltip.js